import React from 'react'

const Ir12127inp = () => {
  return (
    <div>
      <h1>Ir12127inp</h1>
    </div>
  )
}

export default Ir12127inp
